import Blueit from "./images/Blueit.png";
import SocialNetworkAPI from "./images/SocialNetworkAPI.png";
// import MaPeepl from "./images/MaPeepl.png";
import DrDrink from "./images/Dr.Drink.png";
import Chat98 from "./images/chat98.png";
import MoraConsulting from "./images/MoraConsulting.png";
import DeansRoundtable from "./images/DeansRoundtable.png";

const projectObjects = [
  {
    name: "Deans Roundtable",
    cardImg: DeansRoundtable,
    repoUrl: "#",
    deployedUrl: "https://deansroundtable.org/",
    descriptions: "A refactored website",
  },
  {
    name: "Mora Consulting",
    cardImg: MoraConsulting,
    repoUrl: "https://github.com/Paulsig007/shayna-mora-consulting",
    deployedUrl: "https://moraconsulting.co/",
    descriptions: "My first freelance project",
  },
  {
    name: "Chat98",
    cardImg: Chat98,
    repoUrl: "https://github.com/TrueWillB/chat98",
    deployedUrl: "https://chat98-a21833346cf4.herokuapp.com/",
    descriptions: "A nostalgic chatroom app",
  },
  {
    name: "Blueit",
    cardImg: Blueit,
    repoUrl: "https://github.com/Paulsig007/Blueit",
    deployedUrl: "https://blueit-79b9e15820d2.herokuapp.com/",
    descriptions: "A simple blog posting app",
  },
  {
    name: "Social Network API",
    cardImg: SocialNetworkAPI,
    repoUrl: "https://github.com/Paulsig007/mySocialAPI",
    deployedUrl: "https://github.com/Paulsig007/mySocialAPI",
    descriptions: "A Fun little API (No Deployed URL)",
  },
  // {
  //   name: "MaPeepl",
  //   cardImg: MaPeepl,
  //   repoUrl: "https://github.com/Paulsig007/MaPeepl",
  //   deployedUrl: "https://github.com/Paulsig007/MaPeepl",
  //   descriptions: "CLI Employee Tracker (No Deployed URL)",
  // },
  {
    name: "Dr. Drink",
    cardImg: DrDrink,
    repoUrl: "https://github.com/ryantixier/Dr-Drink",
    deployedUrl: "https://ryantixier.github.io/Dr-Drink/",
    descriptions: "A delightful cocktail recipe app",
  },
];

export default projectObjects;
